import { PureComponent, PropsWithChildren } from "react";

export default class DescriptionPaneEntryContent extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-description-pane__entry-content">
        {this.props.children}
      </div>
    );
  }
}
